
module.exports = process.env.VUE_APP_API_BASE_URL || `/api/`;
